import { useLocation } from 'react-router-dom'

// Get query params - ex. query.get('queryParam')
export const useQuery = () => {
    return new URLSearchParams(useLocation().search)
}
